import { Link } from "gatsby";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Col, Container, Row } from "react-bootstrap";
import Img1 from "../../../images/locationgcc/bh/stopvaping.webp";
import Img2 from "../../../images/locationgcc/bh/pureplank.webp";
import Img3 from "../../../images/locationgcc/bh/onsite.webp";

const CaseStudy = [
  {
    title: "Stop Vapping",
    description:
      "Stop Vaping, a digital teen solution, promotes reducing nicotine and e-cigarette use for better health. The app motivates and offers easy paths to a healthier lifestyle.",
    link: "stop-vaping",
    Img: Img1,
    BgColor: "#65CCC0",
    TextColor: "#FFFFFF",
    Alttxt: "app development bahrain",
  },
  {
    title: "Pure Plank",
    description:
      "Pure Plank, an online platform for health and fitness enthusiasts dedicated to maintaining well-being and exercise routines in the comfort of their homes.",
    link: "pure-plank",
    Img: Img2,
    BgColor: "#121212",
    TextColor: "#FFFFFF",
    Alttxt: "app developer in bahrain",
  },
  {
    title: "Onsite",
    description:
      "OnSite Social, a TekRevol creation, bridges the physical and digital realms, forging meaningful real-time connections among users.",
    link: "onsite",
    Img: Img3,
    BgColor: "#53A4C9",
    TextColor: "#FFFFFF",
    Alttxt: "app development bahrain",
  },
];

const StoriesCase = () => {
  return (
    <div className="case_section">
      <Container className="h-100">
        <Row className="h-100">
          {CaseStudy.map((item, index) => (
            <Col
              xs={12}
              md={12}
              lg={10}
              xl={4}
              xxl={4}
              className="my-xl-auto m-lg-auto "
            >
              <div
                className="bg_case"
                style={{ backgroundColor: item.BgColor }}
              >
                <div className="case-content">
                  <h4 style={{ color: item.TextColor }}>{item.title}</h4>
                  <p style={{ color: item.TextColor }}>{item.description}</p>
                  <Link
                    to={
                      item.link
                        ? `/case-studies/${item.link}`
                        : "https://www.tekrevol.com/projects"
                    }
                    className="btn_case"
                  >
                    View Full Casestudy
                  </Link>
                </div>
                <div className="case-img">
                  <LazyLoadImage
                    src={item.Img}
                    effect="blur"
                    alt={item.Alttxt}
                    className="img-fluid"
                  />
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default StoriesCase;
